import React, { useEffect, useRef, useState } from 'react';
import { FiChevronDown } from 'react-icons/fi';
import styles from './Select.module.css';

interface Option {
  label: string;
  value: string;
}

interface Props {
  name: string;
  options: Option[];
  defaultValue?: string;
  onChange?: (value: string) => void;
}

const Select: React.FC<Props> = ({ name, options, defaultValue, onChange }) => {
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState(defaultValue || options[0]?.value);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const onClick = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener('mousedown', onClick);
    return () => document.removeEventListener('mousedown', onClick);
  }, []);

  const selected = options.find((o) => o.value === value) || options[0];

  return (
    <div className={styles.wrap} ref={ref}>
      <input type="hidden" name={name} value={value} />
      <button type="button" className={styles.trigger} onClick={() => setOpen((v) => !v)}>
        <span>{selected?.label}</span>
        <FiChevronDown className={`${styles.chevron} ${open ? styles.chevronOpen : ''}`} />
      </button>
      {open && (
        <div className={styles.menu}>
          {options.map((o) => (
            <div
              key={o.value}
              className={`${styles.option} ${o.value === value ? styles.optionActive : ''}`}
              onClick={() => {
                setValue(o.value);
                setOpen(false);
                onChange?.(o.value);
              }}
            >
              {o.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Select;
